<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-03-25 14:57:58
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-14 19:08:00
 * @FilePath: /privacy-web/src/components/The/TheMenus.vue
-->
<template>
  <div class="menus-main" :class="{ 'menus-main-mobile': isMobile }">
    <TheMenuItem
      v-for="item in menusList"
      :key="item.key"
      :item="item"
      :class="[activeIndex == item.path ? 'menu-active' : '']"
      @switch-router="handleMenu"
    ></TheMenuItem>
  </div>
</template>
<script>
export default {
  name: "TheMenus",
  data() {
    return {
      menusList: [
        // {
        //   path: "/home-page",
        //   name: "首页",
        //   key: "home-page",
        // },
        {
          path: "/home-page-tile",
          name: "首页",
          key: "home-page-tile",
        },
        {
          path: "/privacy-manage",
          name: "隐私管理",
          key: "privacy-manage",
        },
        {
          path: "/privacy-protect",
          name: "隐私保护",
          key: "privacy-protect",
        },
        {
          path: "/privacy-policy",
          name: "隐私政策",
          key: "privacy-policy",
        },
        {
          path: "/privacy-attestation",
          name: "用户中心",
          key: "privacy-attestation",
        },
      ],
    };
  },
  computed: {
    activeIndex() {
      return this.$route.path;
    },
  },
  methods: {
    handleMenu(item) {
      this.$router.push({ path: item });
    },
  },
};
</script>
<style lang="scss" scoped>
.menus-main {
  display: flex;
  align-items: center;
  height: 100%;
}
// .menus-main {
//   display: flex;
//   // margin-right: 4.52rem;
//   margin-left: 1.81rem;
//   height: 100%;
// }
// .menus-main-mobile {
//   margin-left: 0.5rem;
// }
</style>
